import { render, staticRenderFns } from "./ConfApplication.vue?vue&type=template&id=452b21fc&scoped=true&"
import script from "./ConfApplication.vue?vue&type=script&lang=js&"
export * from "./ConfApplication.vue?vue&type=script&lang=js&"
import style0 from "./ConfApplication.vue?vue&type=style&index=0&id=452b21fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452b21fc",
  null
  
)

export default component.exports